import { HeadlineLevel } from '@uikit/components/Headline/consts';
import Container from '../../Container/Container';
import Headline from '../../Headline/Headline';
import { SectionSkewBackground, SectionVariant } from '../../Section/consts';
import Section from '../../Section/Section';
import MagazineTeaserArticle from '../MagazineTeaserArticle/MagazineTeaserArticle';
import type { MagazineFavoriteArticlesProps } from './interfaces';
import styles from './MagazineFavoriteArticles.module.scss';

const MagazineFavoriteArticles = ({
  title = 'Beliebte Artikel',
  articles,
}: MagazineFavoriteArticlesProps) => {
  return (
    <Section
      variant={SectionVariant.LargePadding}
      className={styles.section}
      skewBackground={SectionSkewBackground.White}
      hasFullWidth
      withShadow
      noSpaceBetween
    >
      <Container>
        <Headline className={styles.headline} level={HeadlineLevel.One}>
          {title}
        </Headline>
        <div className={styles.teasersWrapper}>
          {articles?.map(({ id, ...props }, index) => {
            return (
              <MagazineTeaserArticle
                key={id || index}
                {...props}
                thumbnailClassName={styles.teaserThumbnail}
              />
            );
          })}
        </div>
      </Container>
    </Section>
  );
};

export default MagazineFavoriteArticles;
